import { render } from "./ContextBar.vue?vue&type=template&id=44783ce0&scoped=true"
import script from "./ContextBar.vue?vue&type=script&lang=js"
export * from "./ContextBar.vue?vue&type=script&lang=js"

import "./ContextBar.vue?vue&type=style&index=0&id=44783ce0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44783ce0"]])

export default __exports__